import { render, staticRenderFns } from "./UnderWritingQuestions.vue?vue&type=template&id=30966a5e"
import script from "./UnderWritingQuestions.vue?vue&type=script&lang=ts"
export * from "./UnderWritingQuestions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports